import { useState, useEffect } from "react";

import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row, Modal, ModalHeader, ModalBody } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import ApplicatedQuestionList from "../../../../components/ApplicatedQuestionList/ApplicatedQuestionList";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import Statistics from "../../List/statistics";

const EvaluationADRAllocateList = props => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statisticsModal, setStatisticsModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [viewedActivity, setViewedActivity] = useState(null);
  const [viewPDFModal, setViewPDFModal] = useState(false);
  const [selectedActivityId, setSelectedActivityId] = useState(null);

  const rowData = list.find(item => item.id === selectedActivityId);

  const isAlagoasGroup = props.user?.user_roles?.find(
    elem => elem.group_name === "Escola 10 Digital"
  );

  useEffect(() => {
    props.setObj(16, props.currentRoute, props.currentRoute);

    handleTrails();
  }, []);

  const handleTrails = () => {
    setLoading(true);
    const obj = {
      private: false,
      group_id: 86
      // status_id: 2
    };

    axios
      .post(`${URL.api}activity/activity/listEvaluationsByGroupAdm`, obj, {
        headers: { authorization: `Bearer ${props.user.token}` }
      })
      .then(resp => {
        setList(resp.data.data);
        setLoading(false);
      });
  };

  const allocateAction = row => {
    props.history.push(`/evaluation/adr/allocate/${row.id}`);
  };

  const reportAction = row => {
    setStatisticsModal(true);
    setSelectedActivityId(row.id);
  };

  const viewAction = async row => {
    axios
      .get(`${URL.api}activity/activity/singleView/${row.id}`, {
        headers: { authorization: `Bearer ${props.user.token}` }
      })
      .then(activityResponse => {
        setSelectedActivityId(row.id);
        setViewModal(true);
        setViewedActivity(activityResponse.data.data);
      });
  };

  // const rowbackAction = row => {
  //   const obj = {
  //     id: row.id,
  //     status_id: 1
  //   };

  //   axios.post(`${URL.api}activity/activity/update`, obj, {
  //     headers: { authorization: `Bearer ${props.user.token}` }
  //   });
  // };

  const printAction = row => {
    setSelectedActivityId(row.id);
    setViewPDFModal(true);
  };

  return (
    <>
      {statisticsModal && (
        <Statistics
          show
          onClose={() => setStatisticsModal(false)}
          activity_id={selectedActivityId}
          currentRoute={props.currentRoute}
          title={list.find(item => item.id === selectedActivityId)?.nome}
        />
      )}

      <Modal isOpen={viewPDFModal} size="md">
        <ModalHeader toggle={() => setViewPDFModal(!viewPDFModal)}>
          PDF da prova
        </ModalHeader>
        <ModalBody>
          {rowData?.file && (
            <button
              className="d-flex border rounded p-0 w-100"
              type="button"
              onClick={() => window.open(rowData.file.link, "_blank")}
            >
              <div className="bg-warning p-3 h-100 rounded-left">
                <i className="fa fa-file"></i>
              </div>
              <div className="d-flex align-items-center justify-content-start my-3 mx-2">
                {rowData.file.name}
              </div>
            </button>
          )}
        </ModalBody>
      </Modal>

      <Modal
        isOpen={viewModal}
        toggle={() => setViewModal(!viewModal)}
        size="xl"
      >
        <ModalHeader toggle={() => setViewModal(!viewModal)}>
          Visualizar
        </ModalHeader>
        <ModalBody>
          {!viewedActivity ? (
            <Loading top="45" left="50" />
          ) : (
            <ApplicatedQuestionList
              activityId={selectedActivityId}
              currentRoute={props.currentRoute}
              id={viewedActivity.items[0].obj_id}
              history={props.history}
              prototype
              item_id={viewedActivity.item_id}
              result_type={viewedActivity.result_type}
              ended={false}
              end_date={viewedActivity.activity_end}
              viewModal
            />
          )}
        </ModalBody>
      </Modal>

      <div className="animated fadeIn">
        <Row>
          <Breadcrumb current={props.currentRoute} />
          {loading ? (
            <Loading top="45" left="50" />
          ) : (
            <>
              {list ? (
                <div id="list">
                  <DataTable
                    list={list}
                    title="Alocação de avaliações"
                    header={[
                      { name: "id", denomination: "ID" },
                      { name: "name", denomination: "Nome" },
                      { name: "discipline_name", denomination: "Disciplina" },
                      { name: "serie_name", denomination: "Série", width: 108 },
                      {
                        name: "status_name",
                        denomination: "Status",
                        width: 180
                      }
                    ]}
                    action
                    // btnRowback
                    // rowbackAction={rowbackAction}
                    btnView
                    viewAction={viewAction}
                    btnAllocate
                    btnReport={!isAlagoasGroup}
                    btnPrint
                    printAction={printAction}
                    allocateAction={allocateAction}
                    reportAction={reportAction}
                  />
                </div>
              ) : (
                <Loading />
              )}
              <ProtectedRoute routeId={props.currentRoute} />
            </>
          )}
        </Row>
      </div>
      <ProtectedRoute routeId={props.currentRoute} />
    </>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvaluationADRAllocateList);
